export default __webpack_public_path__ + "static/media/payment_icon_1.67165fda.svg";